// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".comment-list{position:relative}.comment-list>.comment__wrapper:not(:first-child){margin-top:1rem}.comment-list>.comment__wrapper:not(:last-child):after{content:\" \";height:1px;bottom:-4px;width:100%;background:#e6e5e5}", ""]);
// Exports
module.exports = exports;
